import React from 'react';
import { Alert } from 'reactstrap';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      messageSent: props.messageSent,
      mailTo: props.mailTo,
      redirectTo: props.redirectTo
    };

    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ messageSent: false });
  }

  render() {
    return (
      <>
        <Alert color="success" isOpen={this.state.messageSent} toggle={this.onDismiss} fade={true}>
          Votre message a été envoyé avec succès !
        </Alert>
        <form className="contact-form" action={"https://formspree.io/" + this.state.mailTo} method="POST" >
          <input type="hidden" name="_next" value={this.state.redirectTo + '?messageSent=true'} />
          <input type="hidden" name="_subject" value="alexandre-gadiou message" />
          <input className="d-none" type="text" name="_gotcha" />
          <div className="form-group row">
            <label htmlFor="inputLastName" className="sr-only">Nom</label>
            <div className="offset-sm-2 col-sm-8">
              <input type="text" name="lastName" className="form-control" id="inputLastName" placeholder="Nom" />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputFirstName" className="sr-only">Prénom</label>
            <div className="offset-sm-2 col-sm-8">
              <input type="text" name="firstName" className="form-control" id="inputFirstName" placeholder="Prénom" />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail" className="sr-only">Email</label>
            <div className="offset-sm-2 col-sm-8">
              <input type="email" name="_replyto" className="form-control" id="inputEmail" placeholder="Email" />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputMessage" className="sr-only">Message</label>
            <div className="offset-sm-2 col-sm-8">
              <textarea rows="10" className="form-control" id="inputMessage" name="message" placeholder="Votre message"></textarea>
            </div>
          </div>

          <div className="buttons-bar form-group row">
            <div className="col-sm-12">
              <button type="submit" className="btn btn-lg btn-primary">Envoyer</button>
            </div>
          </div>
        </form>
      </>
    );
  }
}

export default ContactForm;